import src from "IMAGE";
export default { src, width: 1174, height: 1174, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/webp;base64,UklGRm8AAABXRUJQVlA4TGMAAAAvB8ABAM1VICICHgjAEQIAAICzVQCABAEAAQAAAAAAAAAAAAAAAPQAIAAAAAACiCAgUIB46NV+2wAAABGRNzGBXCmwBYgRXuBgyLofl4fltKS5qHWDfWeu2vbPO5Jo/NWmRgAA"};
